<template>
  <form ref="form" class="box">
    <div class="columns">
      <div class="column is-three-fifths-desktop">
        <b-field
          :label="$t('components.signatureProviderAuthentication.emailLabel')"
          label-position="on-border"
          v-if="hasEmailAuth"
        >
          <b-input maxlength="60" type="email" v-model="authenticationForm.email" required></b-input>
        </b-field>

        <b-field
          :label="$t('components.signatureProviderAuthentication.phoneLabel')"
          label-position="on-border"
          v-if="hasPhoneAuth"
        >
          <b-input maxlength="20" v-model="authenticationForm.phone" required></b-input>
        </b-field>

        <b-field
          :label="$t('components.signatureProviderAuthentication.usernameLabel')"
          label-position="on-border"
          v-if="hasUsernameAuth"
        >
          <b-input maxlength="30" v-model="authenticationForm.username" required></b-input>
        </b-field>
      </div>

      <div class="column is-two-fifths-desktop" v-if="requiresOtp">
        <b-button
          type="is-primary"
          :disabled="!hasValidUserIdentifier"
          expanded
          :loading="sendingOtpRequest"
          @click="requestSms"
        >
          <p v-if="!hasRequestedOtp">
            {{ $t('components.signatureProviderAuthentication.otpButton.label') }}
          </p>
          <p v-else>
            {{ $t('components.signatureProviderAuthentication.otpButton.labelRepeat') }}
          </p>
        </b-button>
      </div>
    </div>

<!-- The password conditional must remain v-show for the validity checks to work
     properly (Otherwise, the form is valid with entering the username only when
     the provider requires OTP) -->
    <b-field
      :label="$t('components.signatureProviderAuthentication.passwordLabel')"
      label-position="on-border"
      v-show="!requiresOtp || hasRequestedOtp"
    >
      <b-input
        type="password"
        maxlength="30"
        password-reveal
        v-model="authenticationForm.password"
        required
      >
      </b-input>
    </b-field>

    <b-field
      :label="$t('components.signatureProviderAuthentication.otpLabel')"
      label-position="on-border"
      v-if="(requiresOtp && hasRequestedOtp) || (!requiresOtp && hasOtp)"
    >
      <b-input maxlength="10" type="number" v-model="authenticationForm.otpCode" required></b-input>
    </b-field>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SignatureProviderAuthentication',
  data () {
    return {
      authenticationForm: {
        email: '',
        phone: '',
        username: '',
        password: '',
        otpCode: ''
      },
      hasRequestedOtp: false,
      hasValidUserIdentifier: false,
      isFormValid: false,
      sendingOtpRequest: false
    }
  },
  created () {
    this.$multiwatch(['authenticationForm.email', 'authenticationForm.phone', 'authenticationForm.username', 'authenticationForm.password', 'authenticationForm.otpCode', 'isFormValid'], function () {
      this.$emit('updateAuthenticationFormData', this.authenticationForm)

      this.isFormValid = this.$refs.form.checkValidity()
      this.$emit('updateAuthenticationFormValidity', this.isFormValid)

      // TODO: check why field refs didn't work.
      let isEmailValid = this.authenticationForm.email !== '' && this.getSelectedSignatureProviderHasEmailAuth()
      let isPhoneValid = this.authenticationForm.phone !== '' && this.getSelectedSignatureProviderHasPhoneAuth()
      let isUsernameValid = this.authenticationForm.username !== '' && this.getSelectedSignatureProviderHasUsernameAuth()

      this.hasValidUserIdentifier = isEmailValid || isPhoneValid || isUsernameValid
    })
  },
  computed: {
    hasEmailAuth () {
      return this.getSelectedSignatureProviderHasEmailAuth()
    },
    hasPhoneAuth () {
      return this.getSelectedSignatureProviderHasPhoneAuth()
    },
    hasUsernameAuth () {
      return this.getSelectedSignatureProviderHasUsernameAuth()
    },
    requiresOtp () {
      return this.getSelectedSignatureProviderRequiresOtp()
    },
    hasOtp () {
      return this.getSelectedSignatureProviderHasOtp()
    }
  },
  methods: {
    ...mapActions([
      'requestOtp'
    ]),
    ...mapGetters([
      'getSelectedSignatureProvider',
      'getSelectedSignatureProviderHasEmailAuth',
      'getSelectedSignatureProviderHasPhoneAuth',
      'getSelectedSignatureProviderHasUsernameAuth',
      'getSelectedSignatureProviderRequiresOtp',
      'getSelectedSignatureProviderHasOtp'
    ]),
    requestSms () {
      this.sendingOtpRequest = true

      let formData = new FormData()

      formData.append('signatureProviderId', this.getSelectedSignatureProvider().id)
      formData.append('email', this.authenticationForm.email)
      formData.append('phone', this.authenticationForm.phone)
      formData.append('username', this.authenticationForm.username)

      this.requestOtp(formData)
        .then(response => {
          this.hasRequestedOtp = true
          this.sendingOtpRequest = false
          if (response.data.length <= 0) {
            this.$modal.show('dialog', {
              title: this.$t('components.signatureProviderAuthentication.otpCheckFailureTitle'),
              text: this.$t('components.signatureProviderAuthentication.otpCheckFailureBody'),
              buttons: [
                {
                  title: 'OK',
                  handler: () => {
                    this.$modal.hide('dialog')
                  }
                }
              ]
            })
          } else {
            this.$modal.show('dialog', {
              title: this.$t('components.signatureProviderAuthentication.otpCheckSuccessTitle'),
              text: this.$t('components.signatureProviderAuthentication.otpCheckSuccessBody') + response.data,
              buttons: [
                {
                  title: 'OK',
                  handler: () => {
                    this.$modal.hide('dialog')
                  }
                }
              ]
            })
          }
        })
        .catch(error => {
          this.sendingOtpRequest = false
          // TODO: Temporary workaround for babel-transform-remove-console
          //       plugin not working.
          // eslint-disable-next-line
          console.error('POST /api/providers/requestOtp failed with error: ', error.message)

          this.$buefy.toast.open({
            duration: 3500,
            message: 'OTP request failed.',
            position: 'is-bottom',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>
